exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".load-mask-parent[data-v-064c7efc]{min-height:auto}.product-info-component[data-v-064c7efc]{position:relative}.product-info-component-components[data-v-064c7efc]{position:absolute;top:15px;right:15px}.product-info-component-components>div[data-v-064c7efc]{float:right;margin-left:3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-064c7efc&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ProductInfoComponent.vue
// module id = 836
// module chunks = 2